export const isTextSlug = (value) => {
  const slug = String(value ?? '').trim();
  return slug !== '' && !isNumericPathParam(slug);
};

export const getProductSlug = (product) => {
  if (product == null || product === '') return '';
  if (typeof product === 'string' || typeof product === 'number') return String(product);
  if (isTextSlug(product.slug)) return String(product.slug).trim();
  return String(product.id ?? '');
};

export const getCategorySlug = (category) => {
  if (category == null || category === '') return '';
  if (typeof category === 'string' || typeof category === 'number') return String(category);
  if (isTextSlug(category.slug)) return String(category.slug).trim();
  return String(category.id ?? '');
};

export const getProductUrl = (product) => `/products/${getProductSlug(product)}`;

export const getCategoryUrl = (category) => `/categories/${getCategorySlug(category)}`;

export const isNumericPathParam = (value) => /^\d+$/.test(String(value ?? ''));

export const resolveCategoryId = (categories, slugOrId) => {
  if (!slugOrId) return null;
  if (isNumericPathParam(slugOrId)) return Number(slugOrId);
  const match = categories.find((item) => item.slug === slugOrId);
  return match?.id ?? null;
};

export const buildPaginatedPath = (basePath, page) => {
  if (!page || page <= 1) return basePath;
  const separator = basePath.includes('?') ? '&' : '?';
  return `${basePath}${separator}page=${page}`;
};
